// extracted by mini-css-extract-plugin
export default {"icon":"uv-cj","reversedIcon":"cQd70","overflow":"Q02Z1","title":"BnAQI","mobile":"EUGwe","listContentTitleColor":"r-wLa"};